export const EMAIL_MODAL_CLASS =
  "flex w-[425px] max-w-[calc(100%-2rem)] flex-col gap-0 overflow-hidden rounded-2xl border border-base-border bg-white p-0 shadow-[0_3px_3px_0_rgba(0,0,0,0.12)] sm:max-w-[425px] max-h-[min(90vh,720px)]";

export const EMAIL_MODAL_BODY_CLASS = "flex flex-col gap-6 overflow-y-auto p-6";

export const EMAIL_MODAL_TITLE_CLASS =
  "w-full pr-8 text-center text-lg font-semibold leading-none tracking-normal text-[#0A0A0A]";

export const EMAIL_MODAL_LABEL_CLASS =
  "text-sm font-medium leading-none text-[#0A0A0A]";

export const EMAIL_MODAL_FIELD_TRIGGER_CLASS =
  "flex h-10 w-full items-center justify-between rounded-md border border-base-border bg-white px-3 text-sm font-normal text-[#0A0A0A] transition-[box-shadow,border-radius]";

export const EMAIL_MODAL_FIELD_TRIGGER_OPEN_CLASS =
  "shadow-[0_1px_2px_rgba(0,0,0,0.06)]";

export const EMAIL_MODAL_DROPDOWN_PANEL_CLASS =
  "z-10 mt-1 overflow-hidden rounded-md border border-base-border bg-white shadow-[0_4px_12px_rgba(0,0,0,0.08)]";

export const EMAIL_MODAL_DROPDOWN_SEARCH_ROW_CLASS =
  "flex h-10 items-center gap-2 border-b border-base-border bg-white px-3";

export const EMAIL_MODAL_DROPDOWN_SEARCH_INPUT_CLASS =
  "h-full min-w-0 flex-1 border-0 bg-transparent px-0 text-sm text-[#0A0A0A] shadow-none placeholder:text-black/45 focus-visible:ring-0";

export const EMAIL_MODAL_DROPDOWN_LIST_CLASS =
  "max-h-48 overflow-y-auto bg-white py-1";

export const EMAIL_MODAL_DROPDOWN_OPTION_CLASS =
  "flex w-full items-center gap-2 px-3 py-2.5 text-left text-sm font-normal text-[#0A0A0A] transition-colors hover:bg-secondary-badge";

export const EMAIL_MODAL_DROPDOWN_OPTION_ACTIVE_CLASS = "bg-secondary-badge";

export const EMAIL_MODAL_CHECKBOX_CLASS =
  "flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-base-border bg-white";

export const EMAIL_MODAL_CHECKBOX_CHECKED_CLASS =
  "border-skyline-2 bg-skyline-2 text-white";

export const EMAIL_MODAL_INPUT_CLASS =
  "h-10 w-full rounded-md border border-base-border bg-white text-sm font-normal text-black/96";

export const EMAIL_MODAL_CLOSE_BUTTON_CLASS =
  "absolute top-0 right-0 rounded-sm text-black/45 transition-opacity hover:text-black/96";

export const EMAIL_MODAL_ADD_EMAIL_BUTTON_CLASS =
  "h-10 w-full justify-start gap-2 rounded-md border border-base-border bg-white px-3 text-sm font-normal text-[#0A0A0A] shadow-none hover:bg-white hover:text-[#0A0A0A] focus-visible:ring-custom-outline/50";

export const EMAIL_MODAL_CANCEL_BUTTON_CLASS =
  "inline-flex h-8 shrink-0 items-center justify-center gap-2 rounded-md border border-base-border bg-white px-4 py-2 text-sm font-normal text-[#0A0A0A] shadow-xs hover:bg-secondary-badge focus-visible:ring-custom-outline/50";

export const EMAIL_MODAL_SAVE_BUTTON_CLASS =
  "inline-flex h-8 shrink-0 items-center justify-center gap-1 rounded-md bg-skyline-2 px-4 py-2 text-sm font-normal text-white hover:bg-skyline-2/80 focus-visible:ring-custom-outline/50";
